import _ from 'lodash'
import { Dictionary } from '@feedyou/utils'

export const omitUndefined = <Key extends keyof any, Value>(
  object: Dictionary<Key, Value>
): Dictionary<Key, Exclude<Value, undefined>> => {
  return _.omitBy(object, val => val === undefined) as any
}

export const deepOverwriteIds = <S>(structure: S, idTransformator: Function, idKey = 'id'): S => {
  if (_.isArray(structure)) {
    // @ts-ignore
    return structure.map(el => deepOverwriteIds(el, idTransformator, idKey))
  }

  if (_.isObject(structure)) {
    return _.mapValues(structure, (val: any, key) => {
      if (key === idKey) {
        return idTransformator(val)
      }

      return deepOverwriteIds(val, idTransformator, idKey)
    })
  }

  return structure
}

export const extractAllIds = <S>(structure: S, idKey = 'id'): any[] => {
  if (_.isArray(structure)) {
    return structure // I <3 PRETTIER
      .map(el => extractAllIds(el, idKey))
      .flat()
  }

  if (_.isObject(structure)) {
    return Object.entries(structure)
      .map(([key, value]) => {
        if (key === idKey) {
          return [value]
        }

        return extractAllIds(value)
      })
      .flat()
  }

  return []
}
